"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingLevelProvider = exports.useHeadingLevel = void 0;
var react_1 = __importDefault(require("react"));
// Components within `common-components` and `design-system` both need
// a reference to this exact context object. However there are circular
// dependency issues between those packages, so this context object exists
// in its own package.
var HeadingLevelContext = react_1.default.createContext({
    level: 1,
});
exports.useHeadingLevel = function () { return react_1.default.useContext(HeadingLevelContext); };
exports.HeadingLevelProvider = function (_a) {
    var _b = _a.level, level = _b === void 0 ? 1 : _b, children = _a.children;
    return (react_1.default.createElement(HeadingLevelContext.Provider, { value: {
            level: level,
        } }, children));
};
